import React from 'react';
import {UploadSingleFileDropZoneLabel} from '../../locales';
import {UploadDropzone, type UploadDropzoneProps} from '../UploadDropzone';

export interface UploadSingleFileDropzoneProps extends UploadDropzoneProps {}

export const UploadSingleFileDropzone = ({
	selectFileLabel,
	title,
	...props
}: UploadSingleFileDropzoneProps) => {
	return (
		<UploadDropzone
			enhancedTitle
			selectFileLabel={
				selectFileLabel ?? UploadSingleFileDropZoneLabel.SELECT_FILE
			}
			title={title ?? UploadSingleFileDropZoneLabel.CHOOSE_FILE_OR_DROP_HERE}
			{...props}
		/>
	);
};
